import { getAuthToken } from '../utils/authUtils'; //
class DischargeService {
  constructor() {
    this.baseURL = process.env.REACT_APP_FIREBASE_BACKEND_API_BASE || 'https://quantumleap-emr-dev.web.app';
    this.apiPath = '/clinical';
  }

  async getAuthHeaders() {
    const token = await getAuthToken();
    return {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    };
  }

  // Discharge a patient from an encounter
  async dischargePatient(encounterId, dischargeData) {
    try {
      const headers = await this.getAuthHeaders();
      const response = await fetch(`${this.baseURL}${this.apiPath}/encounters/${encounterId}/discharge`, {
        method: 'PUT',
        headers,
        body: JSON.stringify({
          ...dischargeData,
          dischargedAt: new Date().toISOString()
        })
      });

      if (!response.ok) {
        throw new Error(`Failed to discharge patient: ${response.statusText}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error discharging patient:', error);
      throw error;
    }
  }

  // Update patient status after discharge
  async updatePatientDischargeStatus(patientId, dischargeData) {
    try {
      const headers = await this.getAuthHeaders();
      const response = await fetch(`${this.baseURL}${this.apiPath}/patients/${patientId}/discharge-status`, {
        method: 'PUT',
        headers,
        body: JSON.stringify({
          ...dischargeData,
          dischargedAt: new Date().toISOString()
        })
      });

      if (!response.ok) {
        throw new Error(`Failed to update patient discharge status: ${response.statusText}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error updating patient discharge status:', error);
      throw error;
    }
  }

  // Get discharge information for an encounter
  async getDischargeInfo(encounterId) {
    try {
      const headers = await this.getAuthHeaders();
      const response = await fetch(`${this.baseURL}${this.apiPath}/encounters/${encounterId}/discharge`, {
        method: 'GET',
        headers
      });

      if (!response.ok) {
        throw new Error(`Failed to get discharge info: ${response.statusText}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error getting discharge info:', error);
      throw error;
    }
  }

  // Get discharge history for a patient
  async getPatientDischargeHistory(patientId) {
    try {
      const headers = await this.getAuthHeaders();
      const response = await fetch(`${this.baseURL}${this.apiPath}/patients/${patientId}/discharge-history`, {
        method: 'GET',
        headers
      });

      if (!response.ok) {
        throw new Error(`Failed to get patient discharge history: ${response.statusText}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error getting patient discharge history:', error);
      throw error;
    }
  }
}

export default DischargeService;
